import { render, staticRenderFns } from "./DevTopBar.vue?vue&type=template&id=db60c4d0&"
import script from "./DevTopBar.vue?vue&type=script&lang=js&"
export * from "./DevTopBar.vue?vue&type=script&lang=js&"
import style0 from "./DevTopBar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports